export { default } from './RedFlagFilter';
